// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import { UIKind } from "../../../define/UIKind";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;


const c_awardList = {
    [50008] : 1,
    [50013] : 1,
    [50012] : 1,
}

const c_gold = 500000000;
@ccclass
export default class CompensateAwardLayer1 extends BasePopUpLayer {

    @property(cc.Node)
    node1: cc.Node = null;
    @property(cc.Node)
    node2: cc.Node = null;

    @property(cc.Node)
    nodeRecv: cc.Node = null;

    @property({ type: cc.Node, displayName:'' })
	nodeGoodsLayout: cc.Node = null;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.node1.active = true;
        this.node2.active = false;

        O1HD.getModules().uiControlModule.hideLoading();
        this.showGoods();
    }

    onClickConfirm() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        this.node1.active = false;
        this.node2.active = true;
    }

    onClickAward() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeLayer();
        this.recvAward();
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeLayer();
    }

    recvAward() {
        for (let i in c_awardList) {
            let c = c_awardList[i];
            NormalGameManager._instance.onPushGoods(Number(i), c);
        }
        NormalGameManager._instance.setGameData({bCompensateAward1: true});
        O1HD.getServices().userSrv.setCoins(c_gold, true, this.nodeRecv);
    }

    async showGoods() {
        let addGoodsList = c_awardList;

        let children = this.nodeGoodsLayout.children;
        children.forEach((v)=> {
            v.active = false;
        })
        let idx = 0;
        for (let i in addGoodsList) {
            let nodeItem = children[idx];
            if (!nodeItem) {
                console.error(`超出限制`);
                break;
            }
            nodeItem.active = true;
            let num = addGoodsList[i];
            let label = nodeItem.getChildByName('label').getComponent(cc.Label);
            let sprGoods = nodeItem.getChildByName('sprGoods').getComponent(cc.Sprite);
            
            let goodsConfig = backPackEventMap()[i];
            let spPath:string = goodsConfig.spPath;
            label.string = goodsConfig.name + '×' + num;

            let gwidth = sprGoods.node.width;
            let gheight = sprGoods.node.height;

            sprGoods.node.active = false;
            if(spPath && spPath != ""){
                let bundle = await getOneBundle( BUNDLE_SMALL_NAME.backPackGameBundle , false);
                bundle.load(`backpackAssets/objSp/${spPath}`
                , cc.SpriteFrame
                , (err,imgs:cc.SpriteFrame)=>{
                    if(err){
                        console.log(err);
                    }else{
                        sprGoods.spriteFrame = imgs;
                        let scale = Math.min(gwidth / sprGoods.node.width, gheight / sprGoods.node.height);
                        sprGoods.node.scale = scale;
                        sprGoods.node.active = true;
                    }
                });
            }
            idx++;

        }
    }

    closeLayer() {
        this.destroyNode();
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.CompensateAwardLayer1);
    }

    // update (dt) {}
}
